export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003';

export interface PublicPlaylist {
  id: string;
  name: string;
  item_count?: number;
  created_at: string;
}

export async function fetchPublicPlaylists(limit = 6): Promise<PublicPlaylist[]> {
  const res = await fetch(`${API_URL}/api/playlists/public?limit=${limit}`);
  if (!res.ok) throw new Error('Failed to fetch public playlists');
  const data = await res.json();
  return data.playlists || [];
}
